(() => {
  'use strict';
  const T = (k, fb) => (window.MUAH_T && window.MUAH_T[k]) || fb;
  const container = document.querySelector('[data-muah-toast-host]');
  if (!container) return;

  const show = (message, opts = {}) => {
    const type = opts.type || 'info';
    const duration = opts.duration || 3000;
    const el = document.createElement('div');
    el.className = `muah-toast muah-toast--${type}`;
    el.setAttribute('role', 'status');
    el.innerHTML = `
      <span class="muah-toast__msg"></span>
      <button type="button" class="muah-toast__close" aria-label="${T('close', 'Schließen').replace(/"/g, '&quot;')}">✕</button>
    `;
    el.querySelector('.muah-toast__msg').textContent = message;
    container.appendChild(el);
    requestAnimationFrame(() => el.classList.add('is-shown'));
    const dismiss = () => {
      el.classList.remove('is-shown');
      el.classList.add('is-leaving');
      setTimeout(() => el.remove(), 250);
    };
    el.querySelector('.muah-toast__close').addEventListener('click', dismiss);
    setTimeout(dismiss, duration);
  };

  document.addEventListener('muah:toast', (e) => {
    if (e.detail && e.detail.message) show(e.detail.message, e.detail);
  });

  window.muahToast = show;
})();

/* ===== Quick-Add Popup (Varianten-Auswahl aus Produktkarten) ===== */
(function(){
  'use strict';
  if (window.__muahQuickAddInit) return;
  window.__muahQuickAddInit = true;

  var T = function(k, fb){ return (window.MUAH_T && window.MUAH_T[k]) || fb; };
  var ROOT = window.MUAH_ROOT || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ICON_X = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>';

  var css = `
  .muah-qa { position: fixed; inset: 0; z-index: 2100; display: none; }
  .muah-qa.is-open { display: block; }
  .muah-qa__backdrop { position: absolute; inset: 0; background: rgba(0,0,0,.5); opacity: 0; transition: opacity .25s ease; }
  .muah-qa.is-open .muah-qa__backdrop { opacity: 1; }
  .muah-qa__panel { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -46%); width: min(440px, 92vw); max-height: 88vh; overflow-y: auto; background: var(--color-bg, #fff); border-radius: 20px; box-shadow: 0 24px 60px rgba(0,0,0,.24); opacity: 0; transition: opacity .25s ease, transform .25s ease; padding: 20px; }
  .muah-qa.is-open .muah-qa__panel { opacity: 1; transform: translate(-50%, -50%); }
  .muah-qa__close { position: absolute; top: 12px; right: 12px; width: 38px; height: 38px; display: inline-flex; align-items: center; justify-content: center; border: 0; background: transparent; color: var(--color-fg, #2a1a15); border-radius: 999px; cursor: pointer; }
  .muah-qa__close:hover { background: var(--color-bg-soft, rgba(0,0,0,.05)); }
  .muah-qa__head { display: flex; gap: 14px; align-items: center; margin: 4px 34px 16px 0; }
  .muah-qa__img { flex: 0 0 auto; width: 74px; height: 74px; border-radius: 14px; overflow: hidden; background: var(--color-bg-soft, #f0f0f0); }
  .muah-qa__img img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .muah-qa__title { font-family: var(--font-body); font-size: 17px; font-weight: 700; color: var(--color-fg, #2a1a15); line-height: 1.25; margin: 0 0 4px; }
  .muah-qa__price { font-size: 16px; font-weight: 700; color: var(--color-accent, #E85D18); }
  .muah-qa__price-compare { font-size: 13px; color: var(--color-fg-faint, #999); text-decoration: line-through; font-weight: 500; margin-left: 6px; }
  .muah-qa__opt { margin-bottom: 14px; }
  .muah-qa__opt-name { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: var(--color-fg-muted, #7a6c64); margin: 0 0 8px; }
  .muah-qa__pills { display: flex; flex-wrap: wrap; gap: 8px; }
  .muah-qa__pill { border: 1.5px solid var(--color-border, #e2d9c4); background: #fff; color: var(--color-fg, #2a1a15); border-radius: 999px; padding: 8px 15px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all .15s ease; }
  .muah-qa__pill:hover { border-color: var(--color-brand, #6E1F26); }
  .muah-qa__pill.is-active { background: var(--color-brand, #6E1F26); border-color: var(--color-brand, #6E1F26); color: #fff; }
  .muah-qa__pill.is-soldout { opacity: .4; text-decoration: line-through; cursor: not-allowed; }
  .muah-qa__add { display: block; width: 100%; margin-top: 8px; padding: 15px; border: 0; border-radius: 12px; background: var(--color-conversion, #4CAF50); color: #fff; font-family: var(--font-body); font-size: 15px; font-weight: 700; cursor: pointer; transition: background .15s ease; }
  .muah-qa__add:hover { background: var(--color-conversion-hover, #3E9142); }
  .muah-qa__add:disabled { background: var(--color-fg-faint, #C9C4C0); cursor: not-allowed; }
  .muah-qa__loading { text-align: center; padding: 40px; color: var(--color-fg-muted, #7a6c64); }
  body.muah-no-scroll { overflow: hidden; }`;
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var modal = document.createElement('div');
  modal.className = 'muah-qa';
  modal.setAttribute('data-muah-qa','');
  modal.innerHTML = '<div class="muah-qa__backdrop" data-qa-close></div><div class="muah-qa__panel" role="dialog" aria-modal="true"><button type="button" class="muah-qa__close" data-qa-close aria-label="' + esc(T('close', 'Schließen')) + '">' + ICON_X + '</button><div data-qa-content><div class="muah-qa__loading">' + esc(T('loading', 'Lädt …')) + '</div></div></div>';
  document.body.appendChild(modal);

  var content = modal.querySelector('[data-qa-content]');
  var current = null;

  function optName(o){ return (o && typeof o === 'object') ? (o.name || '') : o; }
  function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function money(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }

  function open(){ modal.classList.add('is-open'); document.body.classList.add('muah-no-scroll'); }
  function close(){ modal.classList.remove('is-open'); document.body.classList.remove('muah-no-scroll'); }

  modal.querySelectorAll('[data-qa-close]').forEach(function(el){ el.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && modal.classList.contains('is-open')) close(); });

  function findVariant(product, selected){
    return product.variants.find(function(v){
      for (var i=0; i<selected.length; i++){ if (v.options[i] !== selected[i]) return false; }
      return true;
    });
  }

  function render(){
    var p = current.product;
    var v = current.variant;
    var img = (v && v.featured_image && v.featured_image.src) || (p.featured_image) || '';
    var priceHtml = '';
    if (v){
      priceHtml = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price){
        priceHtml += '<span class="muah-qa__price-compare">' + money(v.compare_at_price) + '</span>';
      }
    }
    var html = '<div class="muah-qa__head">';
    if (img) html += '<span class="muah-qa__img"><img src="' + img + '" alt=""></span>';
    html += '<div><p class="muah-qa__title">' + esc(p.title) + '</p><span class="muah-qa__price">' + priceHtml + '</span></div></div>';

    p.options.forEach(function(optRaw, oi){
      var name = optName(optRaw);
      html += '<div class="muah-qa__opt"><p class="muah-qa__opt-name">' + esc(name) + '</p><div class="muah-qa__pills">';
      var values = [];
      p.variants.forEach(function(vr){ if (values.indexOf(vr.options[oi]) === -1) values.push(vr.options[oi]); });
      values.forEach(function(val){
        var active = current.selected[oi] === val;
        html += '<button type="button" class="muah-qa__pill' + (active ? ' is-active' : '') + '" data-qa-opt="' + oi + '" data-qa-val="' + esc(val) + '">' + esc(val) + '</button>';
      });
      html += '</div></div>';
    });

    var avail = v && v.available;
    html += '<button type="button" class="muah-qa__add" data-qa-add' + (avail ? '' : ' disabled') + '>' + esc(avail ? T('add_to_cart', 'In den Warenkorb') : (v ? T('sold_out', 'Ausverkauft') : T('unavailable', 'Nicht verfügbar'))) + '</button>';
    content.innerHTML = html;

    content.querySelectorAll('[data-qa-opt]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var oi = parseInt(btn.getAttribute('data-qa-opt'), 10);
        current.selected[oi] = btn.getAttribute('data-qa-val');
        current.variant = findVariant(current.product, current.selected);
        render();
      });
    });
    var addBtn = content.querySelector('[data-qa-add]');
    if (addBtn) addBtn.addEventListener('click', addToCart);
  }

  function addToCart(){
    if (!current.variant || !current.variant.available) return;
    var btn = content.querySelector('[data-qa-add]');
    if (btn){ btn.disabled = true; btn.textContent = T('adding', 'Wird hinzugefügt …'); }
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: current.variant.id, quantity: 1 }] })
    }).then(function(r){ return r.json(); }).then(function(){
      close();
      document.dispatchEvent(new CustomEvent('muah:cart:open'));
      document.dispatchEvent(new CustomEvent('muah:cart:updated'));
      if (window.muahToast) window.muahToast(T('added', 'Zum Warenkorb hinzugefügt'), { type: 'success' });
    }).catch(function(){
      if (btn){ btn.disabled = false; btn.textContent = T('add_to_cart', 'In den Warenkorb'); }
      if (window.muahToast) window.muahToast(T('error', 'Etwas ist schiefgelaufen'), { type: 'error' });
    });
  }

  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-muah-quick-add]');
    if (!trigger) return;
    e.preventDefault();
    var url = trigger.getAttribute('data-muah-quick-add').split('?')[0];
    content.innerHTML = '<div class="muah-qa__loading">' + esc(T('loading', 'Lädt …')) + '</div>';
    open();
    fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(product){
        var firstAvail = product.variants.find(function(v){ return v.available; }) || product.variants[0];
        current = { product: product, selected: (firstAvail ? firstAvail.options.slice() : []), variant: firstAvail };
        render();
      })
      .catch(function(){
        content.innerHTML = '<div class="muah-qa__loading">' + esc(T('product_load_failed', 'Konnte Produkt nicht laden.')) + '</div>';
      });
  });
})();